(function () {
  if ((window.Shopify && window.Shopify.designMode) || new URLSearchParams(location.search).has('preview_theme_id') || document.documentElement.dataset.egContactTracking) return;
  document.documentElement.dataset.egContactTracking = '1';
  var pendingKey = 'eg-contact-pending-v1';
  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && typeof privacy.currentVisitorConsent === 'function' && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.currentVisitorConsent().analytics === 'yes' && privacy.analyticsProcessingAllowed());
  }
  function emit(name, channel, position) {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    window.gtag('event', name, {send_to: 'G-7J7B3F2J23', contact_channel: channel, link_position: position, page_location: location.origin + location.pathname});
    return true;
  }
  function clearPending() {
    try { sessionStorage.removeItem(pendingKey); } catch (error) {}
  }
  function success() {
    if (document.querySelector('[data-eg-contact-error]')) { clearPending(); return; }
    if (!document.querySelector('[data-eg-contact-success]') || !allowed() || typeof window.gtag !== 'function') return;
    var submitted;
    try { submitted = Number(sessionStorage.getItem(pendingKey)); } catch (error) { return; }
    clearPending();
    var elapsed = Date.now() - submitted;
    if (!submitted || elapsed < 0 || elapsed > 30 * 60 * 1000) return;
    emit('generate_lead', 'contact_form', 'contact_form');
  }
  document.addEventListener('submit', function (event) {
    if (!event.target || event.target.id !== 'ContactForm') return;
    clearPending();
    if (!allowed()) return;
    try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch (error) {}
  }, true);
  document.addEventListener('click', function (event) {
    if (event.button && event.button !== 0) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || !allowed()) return;
    var url;
    try { url = new URL(link.href, location.origin); } catch (error) { return; }
    var name = '', channel = '';
    if (url.protocol === 'tel:' && url.pathname === '+902122845566') { name = 'contact_phone_click'; channel = 'phone'; }
    else if (url.protocol === 'mailto:' && url.pathname.toLowerCase() === 'info@erengoncehukuk.com') { name = 'contact_email_click'; channel = 'email'; }
    else if ((url.hostname === 'wa.me' && url.pathname === '/905368300999') || (url.hostname === 'api.whatsapp.com' && url.searchParams.get('phone') === '905368300999')) { name = 'contact_whatsapp_click'; channel = 'whatsapp'; }
    else if (url.protocol === 'https:' && url.hostname === 'calendar.app.google' && url.pathname === '/VbqVCesG3aPAtfcE6') { name = 'appointment_calendar_open'; channel = 'appointment_calendar'; }
    else if (url.protocol === 'https:' && url.hostname === 'search.google.com' && url.pathname === '/local/writereview' && url.searchParams.get('placeid') === 'ChIJ9fvSdsG3yhQRWCUdM_cYjDM') { name = 'google_review_open'; channel = 'google_review'; }
    else if (url.origin === location.origin) {
      var path = url.pathname.replace(/^\/(en|de)(?=\/|$)/, '');
      var current = location.pathname.replace(/^\/(en|de)(?=\/|$)/, '');
      if (path === '/pages/iletisim' && current !== path) { name = 'contact_page_open'; channel = 'contact_page'; }
      else if ((path === '/pages/online-randevu' || path === '/pages/randevu') && current !== path) { name = 'appointment_page_open'; channel = 'appointment'; }
    }
    if (!name) return;
    var position = link.closest('.eg-quick-contact') ? 'floating' : link.closest('header') ? 'header' : link.closest('footer, .eg-footer') ? 'footer' : 'content';
    emit(name, channel, position);
  }, true);
  document.addEventListener('visitorConsentCollected', function () {
    if (!allowed()) clearPending();
    success();
  });
  document.addEventListener('eg:analytics-ready', success);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', success, {once: true});
  else success();
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) { if (!error) success(); });
  }
})();
